import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardHeader, Grid, Heading } from '@gusto/workbench';

export const PREV_PAYROLL_PROVIDER_KEY = 'PREV_PAYROLL_PROVIDER';

export enum PrevPayrollProviderValues {
  NEW = 'new',
  OTHER = 'Other',
  MANUALLY = 'We do it ourselves manually',
}

const PreviousPayrollProvider = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="prevPayrollProvider"
      id="prevPayrollProvider"
      label="How do you currently run payroll?"
    >
      <Grid rowGap={3} columnGap={2} maxWidth={632} maxWidthMd="100%">
        <SelectableCard
          type="radio"
          aria-label="We’re new to running payroll"
          value={PrevPayrollProviderValues.NEW}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              We’re new to running payroll
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="We use another online payroll software"
          value={PrevPayrollProviderValues.OTHER}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              We use another online payroll software
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="We do it ourselves manually"
          value={PrevPayrollProviderValues.MANUALLY}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              We do it ourselves manually
            </Heading>
          </CardHeader>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default PreviousPayrollProvider;
